/**
 * Connectors Service — Report Templates API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportColumn { 
    field?: string;
    header?: string;
    type?: ReportColumn.TypeEnum;
    /**
     * A masking-STRATEGY TOKEN, not a boolean.
     *
     * This was declared `boolean` while the server reads it as a String. Jackson coerced
     * `false` to the text "false", which is not a strategy name, and the server's
     * fail-closed fallback then masked the column FULL - so the checkbox produced a fully
     * masked column whichever way it was set. The one thing it could not do was what it
     * appeared to do.
     *
     * Blank with `pii` false = visible. Blank with `pii` true = FULL. Unrecognised = FULL.
     */
    mask?: ReportColumn.MaskEnum | string;
    pii?: boolean;
    sortOrder?: number;
}
export namespace ReportColumn {
    /** Masking strategies, matching com.nucleus.core.logger.MaskingStrategy. */
    export const MaskEnum = {
        None: '',
        Full: 'FULL',
        Partial: 'PARTIAL',
        Last4: 'LAST_4',
        Hash: 'HASH',
        Email: 'EMAIL'
    } as const;
    export type MaskEnum = typeof MaskEnum[keyof typeof MaskEnum];

    export const TypeEnum = {
        String: 'STRING',
        Number: 'NUMBER',
        Date: 'DATE',
        Timestamp: 'TIMESTAMP',
        Boolean: 'BOOLEAN'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


